var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"bg-blueGray-100 rounded h-full py-2 px-3 relative"},[(_vm.item.datetime)?_c('span',[_vm._v(" "+_vm._s(_vm.formatTime(_vm.item.datetime))+" ")]):_c('span',[_vm._v(" "+_vm._s(_vm.$t("N/A"))+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }